import { useTranslation } from 'react-i18next';
import { Snackbar } from '@mui/material';
import { SyntheticEvent } from 'react';

interface ClipboardSnackbarProps {
  open: boolean;
  onClose: (event: Event | React.SyntheticEvent<Element, Event>, reason: string) => void;
}

const ClipboardSnackbar = ({ open, onClose }: ClipboardSnackbarProps) => {
  const { t } = useTranslation();

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={2000}
      onClose={onClose}
      message={t('item.basic_info.copied_message')}
    />
  );
};

export default ClipboardSnackbar;
